import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Lock, CreditCard, Loader2 } from "lucide-react";

export const StripeModal = ({ open, onOpenChange, slot, onPay, isPaying }) => {
  if (!slot) return null;
  const commission = (slot.price_discounted * 0.15).toFixed(2);
  const payout = (slot.price_discounted * 0.85).toFixed(2);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="stripe-modal"
        className="max-w-md border-white/10 bg-[#1a1a1a] text-white p-0 overflow-hidden gap-0"
      >
        <div className="bg-[#0a0a0a] px-6 py-4 border-b border-white/10">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-between">
              <span className="font-head text-xl font-bold uppercase tracking-tight">
                {slot.provider_name}
              </span>
              <span className="font-mono text-xs text-[#635bff]">stripe</span>
            </DialogTitle>
          </DialogHeader>
          <DialogDescription className="mt-1 font-mono text-[11px] text-zinc-500">
            Escrow · manual authorization + capture
          </DialogDescription>
        </div>

        <div className="px-6 py-5 space-y-4">
          <div className="rounded-xl border border-white/10 bg-[#121212] p-4">
            <div className="flex items-center justify-between">
              <span className="font-body text-sm text-zinc-300">
                {slot.court_label} · {slot.time_label}
              </span>
              <span className="font-mono text-lg font-bold text-[#25D366]">
                €{slot.price_discounted.toFixed(2)}
              </span>
            </div>
            <div className="mt-3 space-y-1.5 border-t border-white/10 pt-3 font-mono text-[11px] text-zinc-500">
              <div className="flex justify-between">
                <span>SlotSaver commission (15%)</span>
                <span className="text-[#FFCC00]">€{commission}</span>
              </div>
              <div className="flex justify-between">
                <span>Payout to club (85%)</span>
                <span className="text-white">€{payout}</span>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <label className="font-mono text-[11px] text-zinc-500">Credit card</label>
            <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-[#121212] px-3 py-3">
              <CreditCard size={16} className="text-zinc-400" />
              <span className="font-mono text-sm tracking-widest text-zinc-300">
                4242 4242 4242 4242
              </span>
              <span className="ml-auto font-mono text-xs text-zinc-500">12/28 · 123</span>
            </div>
          </div>

          <button
            data-testid="stripe-pay-button"
            onClick={onPay}
            disabled={isPaying}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#635bff] py-3.5 font-head text-lg font-bold uppercase tracking-wide text-white transition-transform hover:scale-[1.01] disabled:opacity-60"
          >
            {isPaying ? (
              <>
                <Loader2 size={18} className="animate-spin" /> Processing…
              </>
            ) : (
              <>
                <Lock size={16} /> Pay €{slot.price_discounted.toFixed(2)}
              </>
            )}
          </button>
          <p className="text-center font-mono text-[10px] text-zinc-600">
            🔒 Simulated payment · no real charge
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StripeModal;
